import { useTranslation } from "react-i18next";

const ChatComposer = ({ draft, setDraft, isSending, onSend }) => {
    const { t } = useTranslation();
    return (
        <div className="border-t border-white/70 bg-white/60 backdrop-blur-xl px-6 py-4 space-y-3 shadow-[0_-10px_30px_rgba(79,70,229,0.12)]">
            <div className="flex flex-col lg:flex-row lg:items-center gap-3">
                <input
                    type="text"
                    placeholder={t('aura composer placeholder')}
                    className="flex-1 rounded-[18px] border border-white/70 bg-white/75 backdrop-blur px-4 py-3 text-sm
                    shadow-[0_18px_46px_rgba(79,70,229,0.14)] focus:outline-none focus:ring-2 focus:ring-indigo-300"
                    value={draft}
                    onChange={(event) => setDraft(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            onSend();
                        }
                    }}
                />
                <button
                    type="button"
                    className="w-full lg:w-auto rounded-[18px] bg-gradient-to-r from-indigo-600 to-violet-700 px-6 py-3 text-sm font-semibold text-white
                    shadow-[0_22px_60px_rgba(79,70,229,0.35)] hover:opacity-95 disabled:opacity-50"
                    onClick={onSend}
                    disabled={!draft.trim() || isSending}
                >
                    {isSending ? t('aura composer sending') : t('aura composer send')}
                </button>
            </div>
            <p className="text-center text-[11px] text-slate-400">
                {t('aura disclaimer')}
            </p>
        </div>
    );
};

export default ChatComposer;
